import styled from 'styled-components';
import MobileStoreButton from '@ertelecom/ui-react/components/buttons/mobileStoreButton';
import { FONTS } from '@ertelecom/ui-react/assets/js/constants';

export const BannerContainer = styled.section`
  width: 100%;
  position: relative;
  background: ${props => props.background || ''};
  padding: 0 130px 0 221px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;

  &:after {
    content: "";
    position: absolute;
    width: 78%;
    max-width: 1480px;
    height: 100%;
    right: -1%;
    bottom: 0;
    background: url("${props => props.backgroundVector || ''}") no-repeat;
    z-index: 0;
    background-size: contain;

    @media (max-width: 1919px) {
      width: 82%;
      max-width: 1027px;
    }

    @media (max-width: 1365px) {
      width: 100%;
      max-width: 846px;
      bottom: -15%;
    }

    @media (max-width: 1023px) {
      max-width: 763px;
      bottom: -1%;
    }

    @media (max-width: 767px) {
      width: 300%;
      bottom: -43%;
      right: -23%;
    }
  }

  @media (max-width: 1919px) {
    padding: 0 50px 0 100px;
  }

  @media (max-width: 1365px) {
    padding: 0 0 0 47px;
  }

  @media (max-width: 1023px) {
    padding: 0 30px 0 47px;
  }

  @media (max-width: 767px) {
    flex-direction: column;
    padding: 0 15px 0 16px;
  }
`;

export const BannerInfo = styled.div`
    width: 44%;
    display: flex;
    flex-direction: column;
    padding-top: 163px;
    padding-bottom: 139px;
    z-index: 1;

    @media(max-width: 1919px) {
        padding-top: 101px;
        padding-bottom: 98px;
    }

    @media(max-width: 1365px) {
        padding-top: 77px;
        padding-bottom: 76px;
    }

    @media(max-width: 1023px) {
        padding-top: 66px;
        padding-bottom: 60px;
    }

    @media(max-width: 767px) {
        width: 100%;
        padding-top: 39px;
        padding-bottom: 38px;
    }
`;

export const BannerTitle = styled.div`
    ${FONTS.H0};
    margin: 0;

    @media(max-width: 1919px) {
        ${FONTS.H1};
    }

    @media(max-width: 1365px) {
        ${FONTS.H2};
    }
`;

export const BannerDesc = styled.div`
    width: 85%;
    max-width: 600px;
    ${FONTS.L};
    margin-top: 15px;

    @media(max-width: 1919px) {
        ${FONTS.S};
        margin-top: 12px;
        width: 90%;
        max-width: 500px;
    }

    @media(max-width: 1023px) {
        ${FONTS.XS};
        margin-top: 9px;
    }

    @media(max-width: 767px) {
        width: 100%;
        max-width: 500px;
        margin-top: 15px;
        ${FONTS.S};
    }
`;

export const BannerButtons = styled.div`
    display: flex;
    margin-top: 60px;

    @media(max-width: 1919px) {
        margin-top: 42px;
    }

    @media(max-width: 1365px) {
        margin-top: 34px;
    }

    @media(max-width: 1023px) {
        margin-top: 30px;
    }

    @media(max-width: 767px) {
        margin-top: 26px;
    }
`;

export const MobileButton = styled(MobileStoreButton)`
    width: 138px;

    @media(max-width: 1919px) {
        width: 132px;
    }

    &:first-child {
        margin-right: 22px;

        @media(max-width: 1919px) {
            margin-right: 29px;
        }

        @media(max-width: 1023px) {
            margin-right: 20px;
        }

        @media(max-width: 767px) {
            margin-right: 8px;
        }
    }
`;

export const BannerImages = styled.div`
    width: 56%;
    max-width: 900px;
    z-index: 1;
    display: flex;
    position: relative;

    @media(max-width: 1919px) {
        max-width: 700px;
    }

    @media(max-width: 1365px) {
        max-width: 560px;
    }

    @media(max-width: 767px) {
        width: 100%;
        max-width: 300px;
        height: 235px;
    }
`;

export const BannerImageItem = styled.img`
    width: 50%;
    max-width: none;
    border: none;
    position: absolute;

    @media(max-width: 1919px) {
        max-width: 350px;
    }

    @media(max-width: 1365px) {
        max-width: 280px;
    }

    @media(max-width: 768px) {
        max-width: 210px;
    }

    &:first-child {
        left: 10%;
        bottom: -41%;

        @media(max-width: 1919px) {
            bottom: -46%;
        }

        @media(max-width: 1365px) {
            left: 10%;
            bottom: -34%;
        }

        @media(max-width: 1023px) {
            left: 14%;
            bottom: -32%;
        }

        @media(max-width: 767px) {
            width: 67%;
            left: -23px;
            bottom: -111px;
        }
    }

    &:last-child {
        width: 51%;
        right: -1%;
        bottom: -29%;

        @media(max-width: 1919px) {
            bottom: -29%;
        }

        @media(max-width: 1365px) {
            right: 0;
            bottom: -16%;
        }

        @media(max-width: 1023px) {
            bottom: -17%;
        }

        @media(max-width: 767px) {
            width: 69%;
            right: -37px;
            bottom: -75px;
        }
    }
`;
